import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomScenariosWidget = () => {
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchScenarios = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/recent-custom-scenarios`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        });

        if (!res.ok) throw new Error('Failed to fetch custom scenarios');

        const data = await res.json();
        setScenarios(data.scenarios || []);
      } catch (err) {
        console.error('Error loading custom scenarios:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchScenarios();
  }, []);

  const startSimulation = (scenarioId) => {
    navigate('/simulator', {
      state: {
        scenarioId,
        isCustomScenario: true,
        fromPage: true
      }
    });
  };

  return (
    <div className="relative bg-gray-100 shadow-inner rounded-lg p-4 overflow-hidden">
      {/* Background pattern */}
      <span
        aria-hidden="true"
        style={{
          backgroundImage: "url('/patterns/bubbles.svg')",
          backgroundSize: "200%",
          backgroundPosition: "10px 180px",
          opacity: 0.1
        }}
        className="pointer-events-none absolute inset-0 bg-repeat z-0"
      />

      {/* Foreground content */}
      <div className="relative z-10">
        <h2 className="text-xl font-bold text-gray-800 text-center mb-4">Recent Custom Scenarios</h2>

        {loading ? (
          <p className="text-sm text-gray-500 animate-pulse text-center">Loading scenarios...</p>
        ) : scenarios.length ? (
          <ul className="space-y-3">
            {scenarios.map((scenario) => (
              <li key={scenario.id} className="bg-white shadow-md rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center">
                    <p className="font-medium text-gray-800 text-sm mr-2">{scenario.title}</p>
                    <span
                      className={`px-2 py-0.5 text-xs font-semibold rounded-full border ${
                        scenario.difficulty <= 2
                          ? 'bg-green-100 text-green-800 border-green-300'
                          : scenario.difficulty === 3
                          ? 'bg-yellow-100 text-yellow-800 border-yellow-300'
                          : 'bg-red-100 text-red-800 border-red-300'
                      }`}
                    >
                      {scenario.difficulty <= 2
                        ? 'Beginner'
                        : scenario.difficulty === 3
                        ? 'Intermediate'
                        : 'Expert'}
                    </span>
                  </div>
                  <button
                    onClick={() => startSimulation(scenario.id)}
                    className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 text-sm"
                  >
                    Start
                  </button>
                </div>
                <p className="text-gray-500 text-sm">
                  {scenario.summary.split(' ').slice(0, 15).join(' ')}...
                </p>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-gray-500 text-center">You haven’t created any custom scenarios yet.</p>
        )}

        <button
          className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 text-sm w-full"
          onClick={() => navigate('/custom-scenarios')}
        >
          View All
        </button>
      </div>
    </div>
  );
};

export default CustomScenariosWidget;
